import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import Tile from '../../components/Tile';
import { FaFileAlt, FaEnvelopeOpenText, FaLightbulb } from 'react-icons/fa';

const tiles = [
  {
    title: 'Generator CV',
    description: 'Stwórz profesjonalne CV w kilka minut, bez zbędnych formalności.',
    icon: <FaFileAlt />,
    gradient: 'purple',
    to: '/cv-career/cv-generator/section/personal-info',
  },
  {
    title: 'Generator listu motywacyjnego',
    description: 'Wygeneruj list motywacyjny dopasowany do Twojej branży i stanowiska.',
    icon: <FaEnvelopeOpenText />,    
    to: '/cv-career/cover-letter',
  },
  {
    title: 'Rozmowa kwalifikacyjna',
    description: 'Przygotuj się do rozmowy rekrutacyjnej i zwiększ swoje szanse na sukces.',
    icon: <FaLightbulb />,
    gradient: 'pink',
    to: '/cv-career/interview-guide',
  },
];

const CvCareer = () => {
  const navigate = useNavigate();
  const handleTileClick = (to) => {
    if (to === '/cv-career/cv-generator/section/personal-info') {
      localStorage.removeItem('cvPersonalInfo');
    }
    navigate(to);
  };

  return (
    <Container className="py-4">
      <h1 className="mb-4 fw-bold text-center">CV & Start kariery</h1>
      <Row className="g-4 justify-content-center">
        {tiles.map((tile) => (
          <Col key={tile.title} xs={12} sm={6} md={4} lg={3}>
            <Tile {...tile} onClick={() => handleTileClick(tile.to)} />
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default CvCareer;
